import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useProductMainImage = (productId: string, fallbackImage: string) => {
  const [mainImage, setMainImage] = useState(fallbackImage);

  useEffect(() => {
    const fetchMainImage = async () => {
      const { data } = await supabase
        .from('product_images')
        .select('image_url')
        .eq('product_id', productId)
        .eq('is_main', true)
        .maybeSingle();
      
      if (data?.image_url) {
        setMainImage(data.image_url);
      } else {
        setMainImage(fallbackImage);
      }
    };

    fetchMainImage();
    
    // Note: Realtime subscription removed to reduce unnecessary WebSocket connections
    // Product images rarely change and updates can be picked up on page refresh
  }, [productId, fallbackImage]);

  return mainImage;
};
